export default {
  web: {
    footer: {
      product: "Producto",
      company: "Empresa",
      download: "Descargar",
      pricing: "Precios",
      bonuses: "Bonos",
      copyright: "Todos los derechos reservados.",
    },
  },
};
